import { KnockoutTournamentEntity } from 'app/interfaces/entity';
import { isNumber } from 'lodash';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

interface BestOfLabelProps {
  round?: number;
  gamesCount?: number;
}

export const BestOfLabel: FC<BestOfLabelProps> = ({ round, gamesCount }) => {
  const tournament = useSelector(currentTournamentSelector.tournament) as KnockoutTournamentEntity;
  const formattedSubMatchesSettings = useSelector(
    currentTournamentSelector.formattedSubMatchesSettings
  );
  const bestOf = useMemo(
    () => Math.max(gamesCount ?? 0, tournament.matchSetupSettings?.bestOf ?? 0),
    [gamesCount, tournament.matchSetupSettings?.bestOf]
  );

  const label = useMemo(() => {
    const defaultLabel = `Best of ${bestOf}`;
    if (!isNumber(round)) {
      return defaultLabel;
    }

    const subMatchBestOfValue = formattedSubMatchesSettings?.[round]?.bestOf;
    return subMatchBestOfValue ? `Best of ${subMatchBestOfValue}` : defaultLabel;
  }, [bestOf, round, formattedSubMatchesSettings]);

  return <>{label}</>;
};
